<template>
  <div>
    <div>
      <form-wizard
        @on-complete="saveProject"
        @on-change="scrollToTop"
        title
        subtitle
        color="#8cc63f"
        finish-button-text="Submit"
        shape="square"
      >
        <tab-content title="Project Details" icon="ti-list">
          <div
            style="
              display: flex;
              align-items: center;
              margin-top: 50px;
              flex-direction: column;
            "
          >
            <div v-if="formType == 'update'" class="col-8">
              <label>Project ID: {{ code }}</label>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Project Name</label>
              <input class="form-control" type="text" required v-model="name" />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Description</label>
              <textarea
                class="form-control"
                type="text"
                required
                v-model="description"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Asset</label>
              <multiselect
                v-model="selectedAsset"
                :options="assets"
                :close-on-select="true"
                placeholder="Select Asset"
                :custom-label="customAssetLabel"
                :show-labels="false"
                track-by="id"
              >
              </multiselect>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Activity</label>
              <multiselect
                v-model="selectedActivity"
                :options="activityList"
                :close-on-select="true"
                placeholder="Select Activity"
                label="name"
                track-by="id"
              >
              </multiselect>
              <!-- <select class="custom-select" v-model="project_activity">
                <option
                  v-for="activity in activityList"
                  :key="activity.name"
                  :value="activity.id"
                >
                  {{ activity.name }}
                </option>
              </select> -->
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Status</label>
              <multiselect
                v-model="selectedStatus"
                :options="statusList"
                :close-on-select="true"
                placeholder="Select Status"
                label="name"
                track-by="id"
              >
              </multiselect>
              <!-- <select class="custom-select" v-model="status">
                <option
                  v-for="status in statusList"
                  :key="status.name"
                  :value="status.id"
                >
                  {{ status.name }}
                </option>
              </select> -->
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Maturity</label>
              <multiselect
                v-model="selectedMaturity"
                :options="maturityList"
                :close-on-select="true"
                placeholder="Select Maturity"
                label="name"
                track-by="id"
              >
              </multiselect>
              <!-- <select class="custom-select" v-model="maturity">
                <option
                  v-for="maturity in maturityList"
                  :key="maturity.name"
                  :value="maturity.id"
                >
                  {{ maturity.name }}
                </option>
              </select> -->
            </div>
            <div
              class="col-8"
              style="
                display: flex;
                justify-content: space-around;
                margin-top: 20px;
              "
            >
              <div>
                <div>Start Date</div>
                <b-calendar v-model="start_date" locale="en-US"></b-calendar>
              </div>
              <div>
                <div>End Date</div>
                <b-calendar v-model="end_date" locale="en-US"></b-calendar>
              </div>
            </div>
            <div style="margin-top: 15px" class="col-8">
              <label>City</label>
              <input class="form-control" type="text" required v-model="city" />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Country</label>
              <select class="custom-select" v-model="country_id">
                <option
                  v-for="country in countries"
                  :key="country.name"
                  :value="country.id"
                >
                  {{ country.name }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Region</label>
              <select class="custom-select" v-model="region_id">
                <option
                  v-for="region in regions"
                  :key="region.name"
                  :value="region.id"
                >
                  {{ region.name }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 15px; display: flex">
              <input
                id="api_enabled"
                v-model="api_enabled"
                type="checkbox"
                class="form-control"
                
                style="height: 20px; width: 20px"
              />
              <span style="margin-left: 5px" for="api_enabled">Recieve Updates Using API</span>
            </div>
            <div
              v-if="api_enabled"
              class="col-8"
              style="display: flex; margin-top: 15px"
            >
              <div style="padding-left: 0" class="col-6">
                <label>API Key</label>
                <input
                  class="form-control"
                  type="password"
                  required
                  v-model="api_key"
                  placeholder="*************"
                />
              </div>
              <div style="padding-right: 0" class="col-6">
                <label>API Secret</label>
                <input
                  class="form-control"
                  type="password"
                  required
                  v-model="api_secret"
                  placeholder="*************"
                />
              </div>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Project Contacts</label>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <input
                class="form-control"
                type="text"
                required
                v-model="platform"
                placeholder="Project Platform"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <input
                class="form-control"
                type="text"
                required
                v-model="contact_person"
                placeholder="Contact Person"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <input
                class="form-control"
                type="text"
                required
                v-model="phone_number"
                placeholder="Phone Number"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <input
                class="form-control"
                type="text"
                required
                v-model="email"
                placeholder="Email"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <input
                class="form-control"
                type="text"
                required
                v-model="website"
                placeholder="Website"
              />
            </div>
          </div>
        </tab-content>
        <tab-content title="Project Value" icon="ti-money">
          <div
            style="
              display: flex;
              align-items: center;
              margin-top: 50px;
              flex-direction: column;
            "
          >
            <div class="col-8" style="margin-top: 15px; display: flex">
              <input
                id="realEstate"
                v-model="is_estate"
                type="checkbox"
                style="height: 20px; width: 20px"
              />
              <span style="margin-left: 5px" for="realEstate">Estate?</span>
            </div>
            <div
              v-if="is_estate"
              class="col-8"
              style="margin-top: 10px; display: flex"
            >
              <div class="col-6" style="padding: 0">
                <label>Estate Area</label>
                <input
                  class="form-control"
                  type="text"
                  required
                  v-model="estate_area"
                />
              </div>

              <div class="col-3" style="padding-right: 0">
                <label>Unit</label>

                <input
                  class="form-control"
                  type="text"
                  required
                  v-model="unit"
                />
              </div>

              <div class="col-3" style="padding-right: 0">
                <label>Unit Price</label>

                <input
                  class="form-control"
                  type="text"
                  required
                  v-model="unit_price"
                />
              </div>
            </div>
            <div class="col-8" style="margin-top: 10px; display: flex">
              <div class="col-8" style="padding: 0">
                <label>Initial Investment</label>
                <input
                  class="form-control"
                  type="text"
                  required
                  v-model="principal_native"
                />
              </div>
              <div style="padding-right: 0" class="col-4">
                <label>Currency</label>
                <select class="custom-select" v-model="currency_id">
                  <option
                    v-for="currency in currencies"
                    :key="currency.code"
                    :value="currency.id"
                  >
                    {{ currency.code }}
                  </option>
                </select>
              </div>
            </div>
            <div
              v-if="currency_id != usdCurrency_id"
              class="col-8"
              style="margin-top: 15px"
            >
              <label>Exchange Rate</label>
              <input
                class="form-control"
                type="text"
                required
                v-model="exchange_rate"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Special Discount</label>
              <input
                class="form-control"
                type="text"
                required
                min="0"
                max="100"
                v-model="special_discount"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Taxation (%)</label>
              <input
                class="form-control"
                type="text"
                required
                v-model="taxation"
              />
            </div>
            <div v-if="activeCurrency" class="col-8" style="margin-top: 25px">
              <div style="padding: 0" class="col-8">
                <label>{{ activeCurrency.code }} Summary</label>
                <div v-if="is_estate" style="display: flex; margin-top: 10px">
                  <div class="col-6" style="padding: 0">
                    {{ estate_area }} Estate Area
                  </div>
                  <div style="font-weight: bold" class="col-6">Unit</div>
                </div>
                <div v-if="is_estate" style="display: flex; margin-top: 10px">
                  <div class="col-6" style="padding: 0">Unit Price</div>
                  <div style="font-weight: bold" class="col-6">
                    {{ unit_price }} {{ activeCurrency.code }}
                  </div>
                </div>
                <div style="display: flex; margin-top: 10px">
                  <div class="col-6" style="padding: 0">Initial Investment</div>
                  <div style="font-weight: bold" class="col-6">
                    {{ principal_native }} {{ activeCurrency.code }}
                  </div>
                </div>
                <div style="display: flex; margin-top: 10px">
                  <div class="col-6" style="padding: 0">Final Price</div>
                  <div style="font-weight: bold" class="col-6">
                    {{ final_price }} {{ activeCurrency.code }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content title="Payment Terms" icon="ti-credit-card">
          <div
            style="
              display: flex;
              align-items: center;
              margin-top: 50px;
              flex-direction: column;
            "
          >
            <div class="col-8" style="margin-top: 15px; display: flex">
              <input
                id="debt"
                v-model="debt"
                type="checkbox"
                style="height: 20px; width: 20px"
              />
              <span style="margin-left: 5px" for="debt">Debt</span>
            </div>
            <div v-if="debt" class="col-8">
              <label>Initial Payment</label>
              <input
                class="form-control"
                type="text"
                required
                v-model="initial_payment"
              />
            </div>
            <div
              v-if="debt"
              class="col-8"
              style="margin-top: 10px; display: flex"
            >
              <div class="col-8" style="padding: 0">
                <label>Installments</label>
                <input
                  class="form-control"
                  type="text"
                  required
                  v-model="installment_number"
                />
              </div>
              <div style="padding-right: 0" class="col-4">
                <label>Installment Period</label>
                <select class="custom-select" v-model="installment_period">
                  <option
                    v-for="installment in periodList"
                    :key="installment.name"
                    :value="installment.id"
                  >
                    {{ installment.name }}
                  </option>
                </select>
              </div>
            </div>
            <div v-if="debt" class="col-8" style="margin-top: 15px">
              <label>Installment Value</label>
              <input
                class="form-control"
                type="text"
                required
                v-model="installment_value"
              />
            </div>
            <div
              v-if="debt"
              class="col-8"
              style="margin-top: 10px; display: flex"
            >
              <div class="col-8" style="padding: 0">
                <label>Cost Increase (%)</label>
                <input
                  class="form-control"
                  type="text"
                  required
                  v-model="cost_increase"
                />
              </div>
              <div style="padding-right: 0" class="col-4">
                <label>Period</label>
                <select
                  style="padding-right: 0"
                  class="custom-select"
                  v-model="cost_increase_period"
                >
                  <option
                    v-for="period in periodList"
                    :key="period.name"
                    :value="period.id"
                  >
                    {{ period.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-8" style="margin-top: 25px">
              <div
                v-if="debt & activeCurrency"
                style="padding: 0"
                class="col-8"
              >
                <label>{{ activeCurrency.code }} Summary</label>
                <div style="display: flex; margin-top: 10px">
                  <div class="col-6" style="padding: 0">Down Payment</div>
                  <div style="font-weight: bold" class="col-6">
                    {{ initial_payment }} {{ activeCurrency.code }}
                  </div>
                </div>
                <div style="display: flex; margin-top: 10px">
                  <div class="col-6" style="padding: 0">Debt</div>
                  <div
                    v-if="initial_payment && final_price"
                    style="font-weight: bold"
                    class="col-6"
                  >
                    {{ final_price - initial_payment }}
                    {{ activeCurrency.code }}
                  </div>
                  <div v-else style="font-weight: bold" class="col-6">
                    {{ activeCurrency.code }}
                  </div>
                </div>
                <div style="display: flex; margin-top: 10px">
                  <div class="col-6" style="padding: 0">Installments</div>
                  <div style="font-weight: bold" class="col-6">
                    {{ installment_value * installment_number }}
                    {{ activeCurrency.code }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content title="Project Files/PDFs" icon="ti-files">
          <div
            style="
              display: flex;
              align-items: center;
              margin-top: 50px;
              flex-direction: column;
            "
          >
            <div class="col-8">
              <div style="display: flex; align-items: center">
                <label class="form-label col-3" style="padding-left: 0"
                  >Project Image</label
                >
                <div
                  v-if="!project_image"
                  class="col-9"
                  style="text-align: center"
                >
                  <media-browser
                    filterBy="images"
                    v-model="project_image"
                    :active="showProjectMediaBrowserModal"
                    @closeRequest="toggleProjectMediaBrowserModal"
                  ></media-browser>
                  <i
                    @click="toggleProjectMediaBrowserModal"
                    style="font-size: 170px"
                    class="fa fa-image"
                  ></i>
                </div>
                <div
                  class="col-9"
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  "
                  v-else
                >
                  <img
                    style="height: 150px"
                    :src="
                      'data:image/' +
                      project_image.extension +
                      ';base64,' +
                      project_image.image
                    "
                    alt=""
                  />
                  <div style="margin-top: 15px">
                    <button
                      style="
                        border-radius: 30px;
                        padding-top: 0px;
                        padding-left: 7px;
                        padding-right: 7px;
                        padding-bottom: 0px;
                      "
                      @click="removeProjectImage()"
                      type="button"
                      class="btn btn-danger"
                    >
                      <i style="font-size: 12px" class="fa fa-trash"></i>
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 10px;
                "
              >
                <div>
                  <label>Add Project Files</label>
                </div>

                <div>
                  <media-browser
                    @fileSelected="addFile"
                    :active="showMediaBrowserModal"
                    @closeRequest="toggleMediaBrowserModal"
                  ></media-browser>
                  <i
                    style="
                      color: rgb(140, 198, 63);
                      font-size: 20px;
                      cursor: pointer;
                    "
                    @click="toggleMediaBrowserModal"
                    class="fa fa-plus-circle"
                  >
                  </i>
                </div>
              </div>
              <div style="border: solid; min-height: 200px; border-width: 2px">
                <table style="width: 100%">
                  <thead>
                    <tr style="text-align: center">
                      <th>#</th>
                      <th>File Name</th>
                      <th>File Type</th>
                      <th>File Size</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      style="text-align: center"
                      v-for="(file, key) in files"
                      :key="key"
                    >
                      <td>{{ key + 1 }}</td>
                      <td>
                        {{ file.caption.split(".").slice(0, -1).join(".") }}
                      </td>
                      <td>{{ file.extension }}</td>
                      <td>{{ bytesToSize(file.size) }}</td>
                      <td>
                        <a
                          style="color: rgb(140, 198, 63) !important"
                          :href="file.url"
                          target="_blank"
                          download
                        >
                          <i class="fa fa-download"></i>
                        </a>
                        <i
                          style="margin-left: 10px; cursor: pointer; color: red"
                          @click="removeFile(key)"
                          class="fa fa-times-circle"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- <div
                  v-for="(file, key) in files"
                  :key="key"
                  class="form-group"
                  style="margin: 0"
                >
                  <div
                    class="input-group"
                    style="display: flex; align-items: center"
                  >
                    <span
                      :style="'min-width:40px;text-align:center;font-size:14px;padding:0px'"
                      >{{ key + 1 }}.</span
                    >
                    <label style="margin: 0"
                      >{{ file.caption.split(".").slice(0, -1).join(".") }}
                    </label>
                    <label style="margin: 0">{{ file.size }} </label>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content title="Project HDI" icon="ti-receipt">
          <div
            style="
              display: flex;
              align-items: center;
              margin-top: 50px;
              flex-direction: column;
            "
          >
            <div class="col-8" style="display: flex">
              <div class="col-8" style="padding: 0">
                <label>Estimated ROI (%)</label>
                <input
                  class="form-control"
                  type="text"
                  required
                  v-model="estimated_roi"
                />
              </div>
              <div style="padding-right: 0" class="col-4">
                <label>Period</label>
                <select class="custom-select" v-model="roi_period">
                  <option
                    v-for="period in periodList"
                    :key="period.name"
                    :value="period.id"
                  >
                    {{ period.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-8" style="margin-top: 15px">
              <label>Risk Level</label>
              <select class="custom-select" v-model="risk_level">
                <option
                  v-for="riskLevel in levels"
                  :key="riskLevel.name"
                  :value="riskLevel.id"
                >
                  {{ riskLevel.name }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Risk-Reward</label>
              <select class="custom-select" v-model="risk_reward">
                <option
                  v-for="riskReward in levels"
                  :key="riskReward.name"
                  :value="riskReward.id"
                >
                  {{ riskReward.name }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Resilience</label>
              <select class="custom-select" v-model="resilience">
                <option
                  v-for="resilience in levels"
                  :key="resilience.name"
                  :value="resilience.id"
                >
                  {{ resilience.name }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Anti-Fragility</label>
              <select class="custom-select" v-model="anti_fragility">
                <option
                  v-for="antifragility in levels"
                  :key="antifragility.name"
                  :value="antifragility.id"
                >
                  {{ antifragility.name }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Impacted-Parties</label>
              <select class="custom-select" v-model="impacted_parties">
                <option
                  v-for="impactedParties in impactedParties"
                  :key="impactedParties.name"
                  :value="impactedParties.id"
                >
                  {{ impactedParties.name }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 25px">
              <div style="padding: 0" class="col-8">
                <label>HDI Result</label>
                <div style="display: flex; margin-top: 10px">
                  <div class="col-6" style="padding: 0">Healthiness Factor</div>
                  <div style="font-weight: bold" class="col-6">/5</div>
                </div>
                <div style="display: flex; margin-top: 10px">
                  <div class="col-6" style="padding: 0">
                    Diversification Factor
                  </div>
                  <div style="font-weight: bold" class="col-6">/5</div>
                </div>
                <div style="display: flex; margin-top: 10px">
                  <div class="col-6" style="padding: 0">
                    Impactfulness Factor
                  </div>
                  <div style="font-weight: bold" class="col-6">/5</div>
                </div>
                <div style="display: flex; margin-top: 10px">
                  <div class="col-6" style="padding: 0">Overall HDI</div>
                  <div style="font-weight: bold" class="col-6">/15</div>
                </div>
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content title="Exit Strategy" icon="ti-new-window">
          <div
            style="
              display: flex;
              align-items: center;
              margin-top: 50px;
              flex-direction: column;
            "
          >
            <div class="col-8" style="display: flex">
              <div class="col-8" style="padding: 0">
                <label>Exit Cause</label>
                <input
                  class="form-control"
                  type="text"
                  required
                  v-model="exit_cause"
                />
              </div>
              <div style="padding-right: 0" class="col-4">
                <label>Exit Analysis</label>
                <select class="custom-select" v-model="exit_analysis">
                  <option
                    v-for="exitAnalysis in periodList"
                    :key="exitAnalysis.name"
                    :value="exitAnalysis.id"
                  >
                    {{ exitAnalysis.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Method</label>
              <textarea
                class="form-control"
                type="text"
                required
                v-model="method"
              />
            </div>
          </div>
        </tab-content>
      </form-wizard>
    </div>
  </div>
</template>
<script>
import ProjectStorer from "../../../../storers/StoreProject";
import ProjectsFilter from "../../../../filters/ProjectsFilter";
import ProjectFinancialsStorer from "../../../../storers/StoreProjectFinancials";
import ProjectRatingStorer from "../../../../storers/StoreProjectRating";
import ProjectFileStorer from "../../../../storers/StoreProjectFile";
import ProjectAccountStorer from "../../../../storers/StoreProjectAccount";
import MediaBrowser from "../../../common/MediaBrowser.vue";
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  props: ["formType", "activeProjectID"],
  data() {
    return {
      maturityList: [
        { id: "shortterm", name: "Short Term" },
        { id: "mediumterm", name: "Medium Term" },
        { id: "longterm", name: "Long Term" },
      ],
      statusList: [
        { id: "active", name: "Active" },
        { id: "inactive", name: "InActive" },
        { id: "notstarted", name: "Not Started" },
        { id: "closed", name: "Closed" },
      ],
      activityList: [
        { id: "active", name: "Active" },
        { id: "semipassive", name: "Semi Passive" },
        { id: "passive", name: "Passive" },
      ],
      periodList: [
        { id: "monthly", name: "Monthly" },
        { id: "quarterly", name: "Quarterly" },
        { id: "biannually", name: "Bi-Annually" },
        { id: "annually", name: "Annually" },
      ],
      levels: [
        { id: "low", name: "Low" },
        { id: "medium", name: "Medium" },
        { id: "high", name: "High" },
      ],
      impactedParties: [
        { id: "community", name: "Community" },
        { id: "environment", name: "Environment" },
        { id: "both", name: "Both" },
        { id: "none", name: "None" },
      ],
      usdCurrency_id: null,
      showMediaBrowserModal: false,
      showProjectMediaBrowserModal: false,
      files: [],
      // Project Details
      code: null,
      name: null,
      project_id: null,
      description: null,
      start_date: null,
      project_image: null,
      end_date: null,
      maturity: null,
      selectedAsset: null,
      selectedActivity: null,
      selectedStatus: null,
      selectedMaturity: null,
      asset_id: null,
      region_id: null,
      country_id: null,
      city: null,
      status: null,
      project_activity: null,
      exit_analysis: null,
      exit_cause: null,
      method: null,
      platform: null,
      contact_person: null,
      phone_number: null,
      email: null,
      website: null,
      api_enabled: false,
      api_key: null,
      api_secret: null,

      // Project Financials
      activeCurrency: null,
      currency_id: null,
      principal_native: 0,
      exchange_rate: 1,
      special_discount: 0,
      is_estate: 0,
      estate_area: null,
      debt: 0,
      initial_payment: null,
      installment_period: null,
      installment_number: null,
      installment_value: null,
      cost_increase: null,
      cost_increase_period: null,
      taxation: 0,
      unit: null,
      unit_price: null,

      // Project Rating
      roi_period: null,
      estimated_roi: null,
      risk_level: null,
      risk_reward: null,
      resilience: null,
      anti_fragility: null,
      impacted_parties: null,

      final_price: null,
    };
  },
  components: {
    MediaBrowser,
    Multiselect,
  },
  created: function () {
    this.$store.dispatch("searchCountries");
    this.$store.dispatch("searchAssets");
    this.$store.dispatch("searchRegions");
    this.$store.dispatch("searchCurrencies").then(() => {
      var usdCurrency = this.currencies.find((currency) => {
        return currency.code == "USD";
      });
      this.usdCurrency_id = usdCurrency.id;
      this.currency_id = usdCurrency.id;
    });
    if (this.formType == "update") {
      var projectsFilter = ProjectsFilter();
      projectsFilter.ids = [this.activeProjectID];
      projectsFilter.with = [
        "projectFinancials",
        "projectRating",
        "files",
        "projectImage",
      ];
      this.$store
        .dispatch("searchProjects", {
          filter: projectsFilter,
          resultMode: "default",
        })
        .then(() => {
          this.fillForm();
        });
    }
  },
  computed: {
    ...mapState({
      regions: (state) => state.regionStore.regionSearch.regions,
      assets: (state) => state.assetStore.assetSearch.assets,
      countries: (state) => state.countryStore.countrySearch.countries,
      currencies: (state) => state.currencyStore.currencySearch.currencies,
      activeProject: (state) => state.projectStore.projectSearch.projects[0],
    }),
  },
  methods: {
    init() {
      // Project Details
      this.name = null;
      this.project_id = null;
      this.description = null;
      this.start_date = null;
      this.end_date = null;
      this.maturity = null;
      this.asset_id = null;
      this.region_id = null;
      this.country_id = null;
      this.city = null;
      this.status = null;
      this.project_activity = null;
      this.exit_analysis = null;
      this.exit_cause = null;
      this.method = null;
      this.platform = null;
      this.contact_person = null;
      this.phone_number = null;
      this.email = null;
      this.website = null;
      this.api_enabled = false;
      this.api_key = null;
      this.api_secret = null;
      // Project Financials
      this.currency_id = null;
      this.principal_native = 0;
      this.exchange_rate = 1;
      this.special_discount = 0;
      this.is_estate = 0;
      this.debt = 0;
      this.initial_payment = null;
      this.installment_period = null;
      this.installment_number = null;
      this.installment_value = null;
      this.cost_increase = null;
      this.cost_increase_period = null;
      this.taxation = 0;
      this.unit = null;
      this.unit_price = null;
      this.roi_period = null;
      this.estimated_roi = null;

      // Project Rating
      this.risk_level = null;
      this.risk_reward = null;
      this.resilience = null;
      this.anti_fragility = null;
      this.impacted_parties = null;
    },
    fillForm() {
      // Project Details
      this.code = this.activeProject.code;
      this.name = this.activeProject.name;
      this.project_id = this.activeProject.project_id;
      this.description = this.activeProject.description;
      this.start_date = this.activeProject.start_date;
      this.end_date = this.activeProject.end_date;
      this.maturity = this.activeProject.maturity;
      this.asset_id = this.activeProject.asset_id;
      this.region_id = this.activeProject.region_id;
      this.country_id = this.activeProject.country_id;
      this.city = this.activeProject.city;
      this.status = this.activeProject.status;
      this.project_activity = this.activeProject.project_activity;
      this.exit_analysis = this.activeProject.exit_analysis;
      this.exit_cause = this.activeProject.exit_cause;
      this.method = this.activeProject.method;
      this.platform = this.activeProject.platform;
      this.contact_person = this.activeProject.contact_person;
      this.phone_number = this.activeProject.phone_number;
      this.email = this.activeProject.email;
      this.website = this.activeProject.website;
      this.project_image = this.activeProject.project_image;
      this.api_enabled = this.activeProject.api_enabled ? true : false;
      this.api_key = this.activeProject.api_key;
      this.api_secret = this.activeProject.api_secret;
      // Project Financials
      this.currency_id = this.activeProject.project_financials.currency_id;
      this.principal_native =
        this.activeProject.project_financials.principal_native;
      this.exchange_rate = this.activeProject.project_financials.exchange_rate;
      this.special_discount =
        this.activeProject.project_financials.special_discount;
      this.is_estate = this.activeProject.project_financials.is_estate;
      this.debt = this.activeProject.project_financials.debt;
      this.initial_payment =
        this.activeProject.project_financials.initial_payment;
      this.installment_period =
        this.activeProject.project_financials.installment_period;
      this.installment_number =
        this.activeProject.project_financials.installment_number;
      this.installment_value =
        this.activeProject.project_financials.installment_value;
      this.cost_increase = this.activeProject.project_financials.cost_increase;
      this.cost_increase_period =
        this.activeProject.project_financials.cost_increase_period;
      this.taxation = this.activeProject.project_financials.taxation;
      this.unit = this.activeProject.project_financials.unit;
      this.unit_price = this.activeProject.project_financials.unit_price;
      this.roi_period = this.activeProject.project_financials.roi_period;
      this.estimated_roi = this.activeProject.project_financials.estimated_roi;
      // Project Rating
      this.risk_level = this.activeProject.project_rating.risk_level;
      this.risk_reward = this.activeProject.project_rating.risk_reward;
      this.resilience = this.activeProject.project_rating.resilience;
      this.anti_fragility = this.activeProject.project_rating.anti_fragility;
      this.impacted_parties =
        this.activeProject.project_rating.impacted_parties;

      if (this.activeProject.files) {
        this.activeProject.files.forEach((file) => {
          this.files.push(file.project_file);
        });
      }
    },

    customAssetLabel(asset) {
      return asset.code + " (" + asset.name + ")";
    },

    saveProject() {
      var project = ProjectStorer();
      var projectFinancial = ProjectFinancialsStorer();
      var projectRating = ProjectRatingStorer();
      var projectAccount = ProjectAccountStorer();

      // Project Details
      if (this.formType == "update") {
        project.id = this.activeProject.id;
        project.code = this.activeProject.code;
        projectFinancial.id = this.activeProject.project_financials.id;
        projectFinancial.project_id =
          this.activeProject.project_financials.project_id;
        projectRating.id = this.activeProject.project_rating.id;
        projectRating.project_id = this.activeProject.project_rating.project_id;
      }
      project.name = this.name;
      project.description = this.description;
      project.start_date = this.start_date;
      project.end_date = this.end_date;
      project.maturity = this.maturity;
      project.asset_id = this.asset_id;
      project.region_id = this.region_id;
      project.country_id = this.country_id;
      project.city = this.city;
      project.status = this.status;
      project.project_activity = this.project_activity;
      project.exit_analysis = this.exit_analysis;
      project.exit_cause = this.exit_cause;
      project.method = this.method;
      project.platform = this.platform;
      project.contact_person = this.contact_person;
      project.phone_number = this.phone_number;
      project.email = this.email;
      project.website = this.website;
      project.api_enabled = this.api_enabled;
      project.api_key = this.api_key;
      project.api_secret = this.api_secret;
      if (this.project_image) {
        project.media_id = this.project_image.id;
      }
      // Project Financials
      projectFinancial.currency_id = this.currency_id;
      projectFinancial.principal_native = this.principal_native;
      if (this.currency_id != this.usdCurrency_id) {
        projectFinancial.exchange_rate = this.exchange_rate;
      } else {
        projectFinancial.exchange_rate = 1;
      }
      projectFinancial.special_discount = this.special_discount;
      projectFinancial.is_estate = this.is_estate ? 1 : 0;
      projectFinancial.debt = this.debt ? 1 : 0;
      projectFinancial.initial_payment = this.initial_payment;
      projectFinancial.installment_period = this.installment_period;
      projectFinancial.installment_number = this.installment_number;
      projectFinancial.installment_value = this.installment_value;
      projectFinancial.cost_increase = this.cost_increase;
      projectFinancial.cost_increase_period = this.cost_increase_period;
      projectFinancial.taxation = this.taxation;
      projectFinancial.unit = this.unit;
      projectFinancial.unit_price = this.unit_price;
      projectFinancial.roi_period = this.roi_period;
      projectFinancial.estimated_roi = this.estimated_roi;
      // Project Rating
      projectRating.risk_level = this.risk_level;
      projectRating.risk_reward = this.risk_reward;
      projectRating.resilience = this.resilience;
      projectRating.anti_fragility = this.anti_fragility;
      projectRating.impacted_parties = this.impacted_parties;

      if (this.formType == "create") {
        var usdCurrency = this.currencies.find((currency) => {
          return currency.code == "USD";
        });
        projectAccount.initial_balance = 0;
        projectAccount.net_balance = 0;
        projectAccount.currency_id = usdCurrency.id;
        project.projectAccount = projectAccount;
      }

      project.financials = projectFinancial;
      project.rating = projectRating;

      if (this.files.length != 0) {
        var projectFiles = [];
        this.files.forEach((file) => {
          var projectFileStorer = ProjectFileStorer();
          if (this.formType == "update") {
            projectFileStorer.project_id = this.activeProject.id;
          }
          projectFileStorer.media_id = file.id;
          projectFiles.push(projectFileStorer);
        });
        project.files = projectFiles;
      }

      this.$emit("saveProject", project);
    },
    toggleProjectMediaBrowserModal() {
      this.showProjectMediaBrowserModal = !this.showProjectMediaBrowserModal;
    },
    toggleMediaBrowserModal() {
      this.showMediaBrowserModal = !this.showMediaBrowserModal;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    addFile(file) {
      this.files.push(file);
    },
    removeFile(key) {
      this.files.splice(key, 1);
    },
    removeProjectImage() {
      this.project_image = null;
    },
    bytesToSize(bytes) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes === 0) return "0 Byte";
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
  },
  watch: {
    selectedAsset() {
      if (this.selectedAsset != null) {
        this.asset_id = this.selectedAsset.id;
      } else {
        this.asset_id = null;
      }
    },
    selectedActivity() {
      if (this.selectedActivity != null) {
        this.project_activity = this.selectedActivity.id;
      } else {
        this.project_activity = null;
      }
    },
    selectedStatus() {
      if (this.selectedStatus != null) {
        this.status = this.selectedStatus.id;
      } else {
        this.status = null;
      }
    },
    selectedMaturity() {
      if (this.selectedMaturity != null) {
        this.maturity = this.selectedMaturity.id;
      } else {
        this.maturity = null;
      }
    },
    principal_native() {
      if (this.special_discount == 0) {
        this.final_price = this.principal_native;
      }
    },
    currency_id() {
      this.activeCurrency = this.currencies.find((currency) => {
        return currency.id == this.currency_id;
      });
      if (this.activeCurrency.code == "USD") {
        this.exchange_rate = 1;
      }
    },
    special_discount() {
      if (this.special_discount > 100) {
        this.special_discount = 100;
      }
      if (this.special_discount < 0) {
        this.special_discount = 0;
      }
      if (
        this.special_discount != null &&
        (this.principal_native != null || this.principal_native != 0)
      ) {
        this.final_price =
          this.principal_native -
          (this.special_discount * this.principal_native) / 100;
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.wizard-icon {
  color: rgb(140, 198, 63) !important;
}
.active .wizard-icon {
  color: rgb(255, 255, 255) !important;
}
.wizard-icon-circle {
  border-color: rgb(140, 198, 63) !important;
  background-color: #fafaf7 !important;
}
.stepTitle {
  color: rgb(140, 198, 63) !important;
  margin-top: 5px;
}
.form-control {
  border: 1px solid #ced4da !important;
  background-image: none;
  border-radius: 5px !important;
  padding: 10px;
}
.custom-select {
  background-color: transparent !important;
}
.wizard-btn {
  margin-bottom: 20px !important;
}
.vue-form-wizard.md .wizard-icon-circle {
  width: 100px;
  height: 100px;
  border-radius: 30px;
  font-size: 24px;
}
.vue-form-wizard .wizard-icon-circle .wizard-icon-container.square_shape {
  border-radius: 20px;
  padding: 32px;
}
.vue-form-wizard.md .wizard-nav-pills > li.active > a .wizard-icon {
  font-size: 34px;
}
.vue-form-wizard .wizard-icon-circle .wizard-icon {
  font-size: 34px;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.multiselect__placeholder {
  color: #495057;
}
.multiselect__option--highlight,
.multiselect__option--highlight:after {
  background: #00a5e3;
}
.multiselect__tags {
  background-color: #fafaf7;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 5px 40px 0 8px;
  font-size: 16px;
  border: 1px solid #ced4da;
}
.multiselect__single {
  padding: 5px;
  background-color: transparent;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/forms/projectForm.vue